<!-- 添加附件 -->
<template>
  <div class="affix-section">
    <a-upload
      :file-list="fileList"
      :multiple="true"
      :custom-request="_uploadFile"
      :disabled="loading"
      :remove="handleRemove"
    >
      <a-button>
        <a-icon :type="loading ? 'loading' : 'upload'" />
        添加附件
      </a-button>
    </a-upload>
  </div>
</template>
<script>
import { uploadFile, deleteFile } from '../api'

export default {
  data() {
    return {
      loading: false,
      fileList: [],
      attachmentIds: [],
    }
  },
  props: ['suffixs', 'maxSize'],
  mounted() {},
  methods: {
    async _uploadFile(file) {
      this.loading = true
      const crtFile = file.file
      const formData = new FormData()
      formData.append('file', crtFile)
      try {
        const { data } = await uploadFile(formData)
        this.fileList.push(crtFile)
        this.attachmentIds.push(data)
        this.loading = false
      } catch (error) {
        this.loading = false
        console.error(error)
      }
    },
    handleRemove(file) {
      this.$confirm({
        title: '提示',
        content: `确定移除 ${file.name} ?`,
        okText: '确认',
        cancelText: '取消',
        onOk: async () => {
          const index = this.fileList.indexOf(file)
          const newFileList = this.fileList.slice()
          try {
            await deleteFile(this.attachmentIds[index])
            this.$message.success('成功')
            newFileList.splice(index, 1)
            this.attachmentIds.splice(index, 1)
            this.fileList = newFileList
          } catch (error) {
            console.error(error)
          }
        },
      })
    },
    // 暴露给父组件的方法
    getAttachmentIds() {
      return this.attachmentIds
    },
  },
}
</script>

<style lang="less" scoped></style>
